import { render, staticRenderFns } from "./document_extraction_zones.vue?vue&type=template&id=1999d136"
import script from "./document_extraction_zones.vue?vue&type=script&lang=js"
export * from "./document_extraction_zones.vue?vue&type=script&lang=js"
import style0 from "./document_extraction_zones.vue?vue&type=style&index=0&id=1999d136&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports